import { render, staticRenderFns } from "./PurchaseTerms.view.vue?vue&type=template&id=55e06d2b&"
import script from "./PurchaseTerms.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseTerms.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e06d2b')) {
      api.createRecord('55e06d2b', component.options)
    } else {
      api.reload('55e06d2b', component.options)
    }
    module.hot.accept("./PurchaseTerms.view.vue?vue&type=template&id=55e06d2b&", function () {
      api.rerender('55e06d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/update/partials/PurchaseTerms.view.vue"
export default component.exports